import React, { Component } from 'react';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as playlistActions from "../../actions/playlist";
import {Redirect} from "react-router-dom";
import AuthService from '../../lib/AuthService';
class Lvignets extends Component {

    constructor(props) {
        super(props);
        this.state = {
            backtoPlaylist : false,
        }
        this.Auth = new AuthService();
        this.listVignets = this.listVignets.bind(this);
    }
    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if( this.props.playlistData.resetPlaylist === true && prevProps.playlistData.resetPlaylist !== this.props.playlistData.resetPlaylist) {
            this.setState({backtoPlaylist : true})
        }
    }
    componentDidMount()
    {
        this.listVignets();
    }

    listVignets(plId)
    {
        let data = { 'plId' : this.props.match.params.id  };
        this.props.getPlaylistVignets(data);
        this.props.getPlaylist(data);
    }
    backToPlaylists() {
        this.props.backToPlaylists();
    }
    render() {

        if (this.state.backtoPlaylist) {
            return <Redirect exact to='/playlists'/>;
        }
        let playlist = this.props.playlistData? this.props.playlistData.playListDetail:undefined;
        let vignetsList = this.props.playlistData? this.props.playlistData.vignetsList:undefined;


        return (
            <div className="wrapper external">

                <div className="container">
                    <div className="playlist-wrapper">
                        <h1>{playlist?playlist.pl_name : ''} <button type="button" className="backtoplaylist" onClick={() => this.backToPlaylists()}>Back To Playlists</button></h1>
                        <div className="playlist-list-wrap">
                            { (!vignetsList || vignetsList.length === 0) &&


                            <div className="alert alert-secondary text-center" role="alert">
                               No nuggets added to this playlsit
                            </div>

                            }

                            { vignetsList && vignetsList.map((list) =>{

                                    list.imgSrc = this.props.pageSettingsData.config.IMGIX_PATH+'assets/slider/cf'+list.vignet_id+'.jpg?fit=crop&h=230&w=265&auto=enhance&dpr=3%203x';

                                    if(list.public_view === 1) {
                                        list.playerUrl = this.props.pageSettingsData.config.PUB_PLAYER_PATH+ list.vignet_id;
                                    }
                                    else{
                                        list.playerUrl = this.props.pageSettingsData.config.UNPUB_PLAYER_PATH+ list.vignet_id+'//';
                                    }

                                return(
                                    <div className="ind-playlist-list">
                                        <a href={list.playerUrl} target="_blank">
                                            <div className="playlist-thumb">
                                                <img
                                                    src={list.imgSrc}
                                                    alt={list.imgSrc}
                                                    className="my-image"/>
                                            </div>
                                            <div className="playlist-desc">
                                                <h5>{list.vignet_title}</h5>
                                            </div>
                                        </a>
                                    </div>
                                );
                            }

                            )}
                        </div>
                    </div>
                </div>

            </div>


        );
    }
}
function mapStateToProps(state) {
    return {
        playlistData  :state.playlist.playlistData,
        pageSettingsData  : state.pages.pageSettings
    };

}

export default  withRouter(connect(mapStateToProps,  {
    getPlaylist : playlistActions.getPlayListDetails,
    getPlaylistVignets : playlistActions.showPlaylistVignets,
    backToPlaylists : playlistActions.resetPlaylistDetail
})(Lvignets));




// WEBPACK FOOTER //
// ./src/components/playlist/ListVignets.js